import { getNameByStatus } from '../../../utils/getnamebystatus-utils';
import React from 'react';
import FuelChart from './fuel-chart';
import TotalCostChart from './total-cost-chart';
import { statusColors } from '../../../utils/status-color-utils';

const DataBoxes = ({ data, attributes }) => {

    const getLightBg = (color) => {
        if (!color) return '#F4F4F4';
        return `${color}33`; // adds ~20% opacity
    };

    return (
        <div className='w-full'>
            <div className='w-full grid sm:grid-cols-3 grid-cols-1 md:gap-6 gap-4'>
                {/* Vehicle Count By Status */}
                {data.vehicleCountByStatus && (
                    <div
                        key="vehicleCountByStatus"
                        className="border rounded-lg p-3 shadow-md"
                    >
                        <h3 className="font-semibold text-gray-800 text-lg">
                            {getNameByStatus('vehicleCountByStatus')}
                        </h3>

                        <div className="mt-3 space-y-2">
                            {data.vehicleCountByStatus.length > 0 ? (
                                data.vehicleCountByStatus.map((item, i) => {
                                    const color = statusColors[item.slug] || statusColors.default;
                                    return (
                                        <div
                                            key={item.slug}
                                            className={`flex items-center justify-between ${i !== data.vehicleCountByStatus.length - 1 ? 'border-b' : ''} pb-2`}
                                        >
                                            <div className="flex items-center space-x-2">
                                                <span
                                                    className="w-3 h-3 rounded-full"
                                                    style={{ backgroundColor: color }}
                                                ></span>
                                                <span className="text-gray-700 text-sm">{item.label}</span>
                                            </div>
                                            <span
                                                className="px-4 py-0.5 rounded-full text-sm font-medium"
                                                style={{
                                                    backgroundColor: getLightBg(color),
                                                    color: color
                                                }}
                                            >
                                                {item.total}
                                            </span>
                                        </div>
                                    );
                                })
                            ) : (
                                <p className="text-gray-500 text-sm">No data available</p>
                            )}
                        </div>
                    </div>
                )}

                {/* Service Reminders */}
                {data.reminderCountByStatus && data.reminderCountByStatus.service && (
                    <div key="serviceReminders" className='border rounded-lg p-3 min-h-28 shadow-md'>
                        <h3 className="font-semibold text-gray-800 text-lg">
                            Service Reminders
                        </h3>
                        <div className="sm:h-full sm:mt-0 mt-3 flex items-center gap-3 justify-around">
                            <div className='flex flex-col items-center gap-3'>
                                <p className='text-green-700 text-4xl font-extrabold'>{data.reminderCountByStatus.service.overdue}</p>
                                <h1 className='text-center lg:text-base text-sm'>Service Overdue</h1>
                            </div>
                            <div className='flex flex-col items-center gap-3'>
                                <p className='text-green-700 text-4xl font-extrabold'>{data.reminderCountByStatus.service.dueSoon}</p>
                                <h1 className='text-center lg:text-base text-sm'>Service Due Soon</h1>
                            </div>
                        </div>
                    </div>
                )}

                {/* Renewal Reminders */}
                {data.reminderCountByStatus && data.reminderCountByStatus.renewal && (
                    <div key="renewalReminders" className='border rounded-lg p-3 min-h-28 shadow-md'>
                        <h3 className="font-semibold text-gray-800 text-lg">
                            Renewal Reminders
                        </h3>
                        <div className="sm:h-full sm:mt-0 mt-3 flex items-center gap-3 justify-around">
                            <div className='flex flex-col items-center gap-3'>
                                <p className='text-purple-700 text-4xl font-extrabold'>{data.reminderCountByStatus.renewal.overdue}</p>
                                <h1 className='text-center lg:text-base text-sm'>Renewal Overdue</h1>
                            </div>
                            <div className='flex flex-col items-center gap-3'>
                                <p className='text-purple-700 text-4xl font-extrabold'>{data.reminderCountByStatus.renewal.dueSoon}</p>
                                <h1 className='text-center lg:text-base text-sm'>Renewal Due Soon</h1>
                            </div>
                        </div>
                    </div>
                )}

                {/* Incident Count By Status */}
                {data.incidentCountByStatus && (
                    <div className="border rounded-lg p-3 shadow-md">
                        <h3 className="font-semibold text-gray-800 text-lg">
                            {getNameByStatus('incidentCountByStatus')}
                        </h3>
                        <div className="mt-3 space-y-2">
                            {data.incidentCountByStatus.length > 0 ? (
                                data.incidentCountByStatus.map((item, i) => {
                                    const color = statusColors[item.slug] || statusColors.default;
                                    return (
                                        <div key={item.slug} className={`flex items-center justify-between ${i !== data.incidentCountByStatus.length - 1 ? 'border-b' : ''} pb-2`}>
                                            <div className="flex items-center space-x-2">
                                                <span className="w-3 h-3 rounded-full" style={{ backgroundColor: color }}></span>
                                                <span className="text-gray-700 text-sm">{item.label}</span>
                                            </div>
                                            <span
                                                className="px-4 py-0.5 rounded-full text-sm font-medium"
                                                style={{
                                                    backgroundColor: getLightBg(color),
                                                    color: color
                                                }}
                                            >
                                                {item.total}
                                            </span>
                                        </div>
                                    );
                                })
                            ) : (
                                <p className="text-gray-500 text-sm">No data available</p>
                            )}
                        </div>
                    </div>
                )}

                {/* Tire Count By Status */}
                {data.tireCountByStatus && (
                    <div className="border rounded-lg p-3 shadow-md">
                        <h3 className="font-semibold text-gray-800 text-lg">
                            {getNameByStatus('tireCountByStatus')}
                        </h3>
                        <div className="mt-3 space-y-2">
                            {data.tireCountByStatus.length > 0 ? (
                                data.tireCountByStatus.map((item, i) => {
                                    const color = statusColors[item.slug] || statusColors.default;
                                    return (
                                        <div key={item.slug} className={`flex items-center justify-between ${i !== data.tireCountByStatus.length - 1 ? 'border-b' : ''} pb-2`}>
                                            <div className="flex items-center space-x-2">
                                                <span className="w-3 h-3 rounded-full" style={{ backgroundColor: color }}></span>
                                                <span className="text-gray-700 text-sm">{item.label}</span>
                                            </div>
                                            <span
                                                className="px-4 py-0.5 rounded-full text-sm font-medium"
                                                style={{
                                                    backgroundColor: getLightBg(color),
                                                    color: color
                                                }}
                                            >
                                                {item.total}
                                            </span>
                                        </div>
                                    );
                                })
                            ) : (
                                <p className="text-gray-500 text-sm">No data available</p>
                            )}
                        </div>
                    </div>
                )}

                {/* Job Count By Status */}
                {data.jobCountByStatus && (
                    <div className="border rounded-lg p-3 shadow-md">
                        <h3 className="font-semibold text-gray-800 text-lg">
                            {getNameByStatus('jobCountByStatus')}
                        </h3>
                        <div className="mt-3 space-y-2">
                            {data.jobCountByStatus.length > 0 ? (
                                data.jobCountByStatus.map((item, i) => {
                                    const color = statusColors[item.slug] || statusColors.default;
                                    return (
                                        <div key={item.slug} className={`flex items-center justify-between ${i !== data.jobCountByStatus.length - 1 ? 'border-b' : ''} pb-2`}>
                                            <div className="flex items-center space-x-2">
                                                <span className="w-3 h-3 rounded-full" style={{ backgroundColor: color }}></span>
                                                <span className="text-gray-700 text-sm">{item.label}</span>
                                            </div>
                                            <span
                                                className="px-4 py-0.5 rounded-full text-sm font-medium"
                                                style={{
                                                    backgroundColor: getLightBg(color),
                                                    color: color
                                                }}
                                            >
                                                {item.total}
                                            </span>
                                        </div>
                                    );
                                })
                            ) : (
                                <p className="text-gray-500 text-sm">No data available</p>
                            )}
                        </div>
                    </div>
                )}
            </div>

            <div className='grid md:grid-cols-2 grid-cols-1 lg:gap-6 gap-4 lg:mt-6 mt-4'>
                {/* Fuel Expenses Chart */}
                {data.expensesSumMonthlyFuel && (
                    <div key="expensesSumMonthlyFuel" className='border rounded-lg p-3 shadow-md'>
                        <h3 className="font-semibold text-gray-800 text-lg">
                            Fuel Expenses (YTD - Monthly)
                        </h3>
                        <div className="mt-2 space-y-1">
                            <FuelChart data={data.expensesSumMonthlyFuel} unit={attributes?.currency} />
                        </div>
                    </div>
                )}

                {/* Total Expenses Chart */}
                {data.expensesSumMonthlyAccount && (
                    <div key="expensesSumMonthlyAccount" className='border rounded-lg p-3 shadow-md'>
                        <h3 className="font-semibold text-gray-800 text-lg">
                            Total Expenses (YTD - Monthly)
                        </h3>
                        <div className="mt-2 space-y-1">
                            <TotalCostChart data={data.expensesSumMonthlyAccount} unit={attributes?.currency} />
                        </div>
                    </div>
                )}
            </div>
        </div>
    );
};

export default DataBoxes;